import type { JSX } from 'react';
import { styled } from '@mui/material';
import { BIOMARKER_DOT_RADIUS } from '@/constants/PatientDashboard/patientTimeline';

const GLYPH_WIDTH = 22;
const GLYPH_HEIGHT = 10;
const GLYPH_LINE_START_X = 1;
const GLYPH_LINE_THICKNESS = 2;

const Glyph = styled('svg')({
  flexShrink: 0,
  display: 'block',
});

interface IProps {
  colour: string;
}

export default function ChartSeriesGlyph({ colour }: IProps): JSX.Element {
  return (
    <Glyph
      width={GLYPH_WIDTH}
      height={GLYPH_HEIGHT}
      viewBox={`0 0 ${GLYPH_WIDTH} ${GLYPH_HEIGHT}`}
      aria-hidden="true"
    >
      <line
        x1={GLYPH_LINE_START_X}
        y1={GLYPH_HEIGHT / 2}
        x2={GLYPH_WIDTH - BIOMARKER_DOT_RADIUS}
        y2={GLYPH_HEIGHT / 2}
        stroke={colour}
        strokeWidth={GLYPH_LINE_THICKNESS}
        strokeLinecap="round"
      />
      <circle
        cx={GLYPH_WIDTH - BIOMARKER_DOT_RADIUS}
        cy={GLYPH_HEIGHT / 2}
        r={BIOMARKER_DOT_RADIUS}
        fill={colour}
      />
    </Glyph>
  );
}
